"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5614],{

/***/ 6643:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/the_volte_logo_black.aa1c8b7c.svg","height":329,"width":1314});

/***/ }),

/***/ 35614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LogoLink": function() { return /* reexport */ LogoLink; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./src/images/the_volte_logo_black.svg
var the_volte_logo_black = __webpack_require__(6643);
;// CONCATENATED MODULE: ./src/components/atoms/LogoLink/LogoLink.tsx







var LogoLink = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: paths/* paths.home */.H.home,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
            w: [
                "7rem",
                null,
                null,
                "9rem"
            ],
            cursor: "pointer",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_svg_esm/* ReactSVG */.Q, {
                src: the_volte_logo_black/* default.src */.Z.src
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/atoms/LogoLink/index.ts



/***/ }),

/***/ 4032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ paths; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);

var baseUrl = "/";
var slugUrl = ":slug";
var accountBaseUrl = "".concat(baseUrl, "account/");
var checkoutBaseUrl = "".concat(baseUrl, "checkout/");
var pageBaseUrl = "".concat(baseUrl, "page/");
var categoryBaseUrl = "".concat(baseUrl, "category/");
var collectionBaseUrl = "".concat(baseUrl, "collection/");
var paths = {
    notFound: "".concat(baseUrl, "404"),
    accountConfirm: "".concat(baseUrl, "account-confirm"),
    // cart: `${baseUrl}cart`,
    categoryBase: "".concat(categoryBaseUrl),
    category: "".concat(categoryBaseUrl).concat(slugUrl),
    dresses: "".concat(baseUrl).concat(slugUrl),
    clothing: "".concat(baseUrl).concat(slugUrl),
    collectionBase: "".concat(collectionBaseUrl),
    collection: "".concat(collectionBaseUrl).concat(slugUrl),
    guestOrderDetail: "".concat(baseUrl, "order-history/:token"),
    home: baseUrl,
    login: "".concat(baseUrl, "login"),
    processingpayment: "".concat(baseUrl, "processing-payment"),
    orderFinalized: "".concat(baseUrl, "order-finalized"),
    pageBase: "".concat(pageBaseUrl),
    page: "".concat(pageBaseUrl, ":slug"),
    passwordReset: "".concat(baseUrl, "reset-password"),
    product: "".concat(baseUrl, "item/").concat(slugUrl),
    search: "".concat(baseUrl, "search"),
    defaultCategory: "".concat(baseUrl, "dresses"),
    orderRating: "".concat(baseUrl, "review/rating"),
    /**
   * Checkout
   */ checkout: checkoutBaseUrl,
    checkoutAddress: "".concat(checkoutBaseUrl, "address"),
    checkoutPayment: "".concat(checkoutBaseUrl, "payment"),
    checkoutPaymentConfirm: "".concat(checkoutBaseUrl, "payment-confirm"),
    checkoutReview: "".concat(checkoutBaseUrl, "review"),
    checkoutShipping: "".concat(checkoutBaseUrl, "shipping"),
    /**
   * Account section
   */ account: accountBaseUrl,
    accountAddressBook: "".concat(accountBaseUrl, "address-book"),
    wishlist: "".concat(accountBaseUrl, "wishlist"),
    // FIXME: User order should be accessible via order id
    accountOrderDetail: "".concat(accountBaseUrl, "order-history/:token"),
    accountOrderHistory: "".concat(accountBaseUrl, "order-history"),
    accountOrderOverview: "".concat(accountBaseUrl, "order-history/:token/overview"),
    dashboard: "".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .siteUrl */ .or, "/dashboard/"),
    accountMessages: "".concat(accountBaseUrl, "messages"),
    accountLending: "".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .siteUrl */ .or, "/dashboard/"),
    accountLendingProducts: "".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .siteUrl */ .or, "/dashboard/products"),
    warehouse: "".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .siteUrl */ .or, "/dashboard/warehouses/:warehouseId"),
    createWarehouse: "".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .siteUrl */ .or, "/dashboard/warehouses/add"),
    /**
   * Designers
   */ designers: "".concat(baseUrl, "designers"),
    designer: "".concat(baseUrl, "designers/").concat(slugUrl),
    /**
   * Promo pages
   */ partnerPromo: "".concat(baseUrl, "wear-the-dress-share-the-dress"),
    /**
   * Partner portal
   */ partners: "".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .siteUrl */ .or, "/partners/"),
    /**
   * Enquire
   */ enquire: "/item/:slug/enquire/"
};


/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

}]);